import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/CaseStudy/CaseStudy.tsx");
